export default {
  label: {
    tooltip: 'Esta investigación pertenece al ambiente de prueba (staging)',
    environment: 'Staging',
  },
};
